import { useEffect, useState } from "react";
import { subscribeProcessedProducts } from "../../../components/firebase/firestore";

export default function useProcessedProducts(productId) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setLoading(true);
    setError(false);
    return subscribeProcessedProducts((items) => {
      setProducts(items);
      setLoading(false);
    }, () => {
      setProducts([]);
      setError(true);
      setLoading(false);
    }, productId);
  }, [attempt, productId]);

  return { products, loading, error, retry: () => setAttempt((value) => value + 1) };
}
